module.exports = __webpack_public_path__ + "img/other.fa7a0435.png";